// polyfill
import 'core-js/features/map';
import 'core-js/features/set';
import React from 'react';
import ReactDOM from 'react-dom';
import Routes from 'Routes';
import { iosWebViewRebound, isCsairApp } from '@csair/emp-helpers';
import createStore from './store/createStore';
import App from './containers/AppContainer';
import { getRefundAppStore } from './utils/util_appRefundStore';
import './styles/index.less';
import sensors from 'sa-sdk-javascript';
import { userAgentType, getPageName } from 'Utils';
// 关闭ios webview橡皮筋效果
iosWebViewRebound(false);

// init state
let initialState = window.__INITIAL_STATE__;
if (
  window.location.href.indexOf(Routes.ticket.child.refundApply.path) !== -1 &&
  isCsairApp()
) {
  const state = getRefundAppStore();
  if (state)
    initialState = {
      EdorsedApply: state,
    };
}

const store = createStore(initialState);

window.errorProcess = function() {
  const {
    current: { flights, psgs },
    EdorsedApply: { flightList, psgList },
  } = store.store.getState();
  // 乘机人：只有一个旅客，就默认传该旅客（不管有无勾选），如果多个，就传勾选旅客
  // 航段：只有一段，默认该段，如果有多个，就传勾选的航段
  window.sessionStorage.setItem(
    'emp-mobile',
    JSON.stringify({
      ticket: {
        flightList:
          flightList.length === 1
            ? flightList
            : flightList.filter((item, i) => flights.includes(i)),
        psgList:
          psgList.length === 1
            ? psgList
            : psgList.filter((item, i) => psgs.includes(i)),
      },
    })
  );
};

let result = 'Y';
if (
  window.CSNativeObject &&
  typeof window.CSNativeObject.getAnalyticsSwitch == 'function'
) {
  // 字符串格式的结果：{"status":"Y/N"}
  let res =
    typeof window.CSNativeObject.getAnalyticsSwitch() === 'string'
      ? JSON.parse(window.CSNativeObject.getAnalyticsSwitch())
      : window.CSNativeObject.getAnalyticsSwitch();
  result = res.status;
}

let channelP = '';
if (userAgentType() === 'APP Android') {
  channelP = '安卓';
} else if (userAgentType() === 'APP IOS') {
  channelP = 'iOS';
} else if (userAgentType() === '小程序') {
  channelP = '小程序';
} else if (navigator.userAgent.toLowerCase().includes('toutiaomicroapp')) {
  channelP = '抖音小程序';
} else if (result === 'Y' && location.href.includes('language=en')) {
  channelP = '谷歌';
} else if (userAgentType() === 'H5 移动') {
  channelP = '触屏';
}

// 注册公共属性
sensors.registerPage({
  page_url: location.href,
  $referrer: document.referrer,
  platform_source: channelP,
  Uapp_id: 'EXTWEB',
  Uapp_name: '附加服务前端',
  language: location.href.includes('language=en') ? '英文' : '中文',
  page_name: getPageName(location.hash),
  refer_page_name: getPageName(document.referrer),
  product_version: location.href.includes('language=en') ? '海外版' : '标准版',
  track_version: '3.0版本',
  version: '【退改前端】退改接入神策埋点需求+20260611',
  business_unit: '机票退改',
  is_login: true,
});

sensors.init({
  // server_url: 'https://test-gate-mata.csair.com/sa?project=CSAIR_NEW',
  server_url: 'https://gate-mata.csair.com/sa?project=CSAIR_NEW',
  is_track_single_page: true, // 单页面配置，默认关闭。开启后自动监听 URL 有变化就会触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'default',
  },
  show_log: false
});
sensors.quick('autoTrack'); //用于采集 $pageview 事件。

if (result === 'Y') {
  window.$sensors = { sensors };
} else {
  window.$sensors = {
    sensors: {
      track(q, s) {},
    },
  };
}

// Render Setup
const MOUNT_NODE = document.getElementById('root');
const routes = require('./routes').default(store.store);
ReactDOM.render(<App {...store} routes={routes} />, MOUNT_NODE);



// WEBPACK FOOTER //
// ./src/index.js